/* import __COLOCATED_TEMPLATE__ from './owner-assignee-dropdown.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();